export default "__VITE_ASSET__f22d2914__"